import Search from '../HomeComponent/Search'
import Header from './Header'
import { Dialog } from './Wrapper'

Dialog.Header = Header
Dialog.Search = Search
export default Dialog